const solutionDetail = {
  financial: {
    noTitleType: false,
    title: "金融直播运营解决方案",
    image: "./images/financial.png",
    tips:
      "私有化定制企业的互联网金融直播间，含服务器软硬件资源\n" +
      "支持、直播平台后期维护、直播承制服务、直播运营支持等\n" +
      "全流程服务。可使各企业根据自身业务需求设置直播规则，\n" +
      "专注提升业务内容和服务质量，让多种创新营销模式成为可\n" +
      "能。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "以业务为全面导向",
        icon: "./images/financial1.png",
        tips:
          "将直播玩法与业务需求契合，无论带货金融产品还是普通商品，均支持量身定制功能配置。"
      },
      {
        title: "高清画质、流畅直播",
        icon: "./images/financial2.png",
        tips:
          "完美支持百万级别并发量，2800+网络节点智能调度，保证弱网环境直播依然流畅，全球CDN 覆盖，稳定安全。"
      },
      {
        title: "全方位互动、激发热度",
        icon: "./images/financial3.png",
        tips:
          "自定义带货袋、指定观众连麦、一对一聊天，多种互动形式，全方位实时互动交流，支持云导播台。"
      },
      {
        title: "运营支持导向",
        icon: "./images/financial4.png",
        tips:
          "金牌直播团队联合运营，快速支持策划导演等全链路直播方案，活动前赴实地踩点，确认细节，设备、人员互备保障。"
      }
    ]
  },
  community: {
    noTitleType: false,
    title: "社群运营解决方案",
    image: "./images/community.png",
    tips:
      "通过社群运营方式支持全渠道获客，汇集全渠道数据，承接全渠道流量；同时，激活银行私域流量，理解用户深度需求，提供个性化营销策略，提升流量转化率，降低获客成本，提高用户留存率，最大化存量用户价值。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "拉新促活裂变",
        icon: "./images/community1.png",
        tips:
          "提供多场景互动营销，激励用户自发性地传播和推广，实现高效、持续的用户拉新增长。 "
      },
      {
        title: "降低获客成本",
        icon: "./images/community2.png",
        tips:
          "告别传统营销的高成本模式，依托社群营销，以更低的成本获取流量。"
      },
      {
        title: "深挖客户价值",
        icon: "./images/community3.png",
        tips:
          "深入众多业务场景，理解并刺激用户消费需求，精准高效锁定目标人群。"
      },
      {
        title: "精准分层营销",
        icon: "./images/community4.png",
        tips:
          "洞察和分析用户标签及画像，实现精细化差别化运营，提升用户体验及转化率。"
      }
    ]
  },
  internet: {
    noTitleType: false,
    title: "互联网全栈运营解决方案",
    image: "./images/internet.png",
    tips:
      "通过输出全栈运营解决方案，针对性地解决中小企业、银行等在线上运营过程中遇到的实际业务问题。通过全栈运营达成用户增长、留存、活跃、消费、自传播的实际效果。用成熟的互联网方法论赋能品牌建设与营销推广，构建品牌形象，提升品牌音量。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "",
        icon: "./images/internet1.png",
        tips:
          "提供面向实际业务问题的全栈运营与营销解决方案，同步解决运营与营销需求。"
      },
      {
        title: "",
        icon: "./images/internet2.png",
        tips:
          "提供全栈运营与营销职能支持。运营向如产品运营、用户运营、活动运营、内容运营；营销向如PR及品牌营销（含新媒体短视频）。"
      },
      {
        title: "",
        icon: "./images/internet3.png",
        tips:
          "提供运营方法论输出与培训。含文案创作、策划线上线下活动、获取及分析运营数据、策划及制作H5、进行品牌形象建设及推广、扩散PR音量、进行搜索引擎优化（SEO/SEM）、应用商店优化（ASO）、寻找及激活BD资源、用户运营体系搭建（含会员运营）、触达——转化——复购的全链路产品运营等。"
      }
    ]
  }
};
export default solutionDetail;
